import React from 'react';
import { Dialog } from '@mui/material';
import useProfileEditorDialog from '../../hooks/useProfileEditorDialog';
import { ProfileForm } from '../profile/ProfileForm';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import { UserProfileEdit } from '../admin/users/UserProfileEdit';
import StyledTitle from '../styled/Dialog/StyledTitle';

const ProfileEditorDialog: React.FC<{ open: boolean }> = (props) => {
    const profileDialog = useProfileEditorDialog();
    const { t } = useTranslation();
    const handleClose = () => {
        profileDialog.closeAllDialog();
    };

    const handleSuccess = () => {
        profileDialog.setProfileDialogClosedWithSuccess(true);
        profileDialog.closeAllDialog();
    };

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            maxWidth={'sm'}
            fullWidth
        >
            <StyledDialogTitle>
                <StyledTitle>{t('PROFILE.PROFILE_DIALOG.TITLE')}</StyledTitle>
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
            </StyledDialogTitle>
            <StyledDialogContent>
                {!profileDialog.isAdmin && (
                    <ProfileForm submitSuccess={handleSuccess} />
                )}
                {profileDialog.isAdmin && (
                    <UserProfileEdit submitSuccess={handleSuccess} />
                )}
            </StyledDialogContent>
        </Dialog>
    );
};

export default ProfileEditorDialog;
